import React from 'react';
import AboutContent from '../about/AboutContent';
export default function AboutPage(){ return <AboutContent />; }
